export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^[AC-FHKNPRTV-Y][0-9][0-9W]\s[0-9AC-FHKNPRTV-Y]{4}$/i));
    }
}
